import React from 'react'

import Toolbar from '../../../Classroom/components/Media/components/Toolbar'
import Wrapper from '../../../Classroom/components/Media/components/Wrapper'
import {
  useRecordingState,
  useRecordingMainParticipant,
  useRecordingScreenSharing
} from '../../hooks'

import MainParticipant from './MainParticipant'
import Screenshare from './Screenshare'
import ParticipantList from './ParticipantList'

const RecordingMedia = () => {
  const { panels } = useRecordingState()
  const participant = useRecordingMainParticipant()
  const screenshare = useRecordingScreenSharing()
  const minimized = panels.length > 0

  return (
    <Wrapper minimized={minimized}>
      {minimized && <Toolbar />}
      {screenshare.sharing ? (
        <Screenshare minimized={minimized} />
      ) : participant?.online ? (
        <MainParticipant minimized={minimized} />
      ) : (
        <MediaFallback />
      )}
      <ParticipantList />
    </Wrapper>
  )
}

const MediaFallback = () => {
  return (
    <div className='gp-Recording-player-media-fallback'>
      Participants will appear here
    </div>
  )
}

export default RecordingMedia
